import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export interface CountryItem {
    readonly id: number;
    readonly code: string;
    readonly default: boolean;
    readonly euMember: boolean;
    readonly name: string;
    readonly externalId: string;
}

interface CountryInternalItem {
    readonly code: string;
    readonly default: boolean;
    readonly euMember: boolean;
    readonly id: number;
    readonly name: string;
    readonly externalId: string;
    readonly version: string;
}

export class CountryCollectionQuery extends Query<CountryItem[]> {}

export class CountryCollectionQueryHandlerBase implements QueryHandler<CountryCollectionQuery, CountryItem[]> {
    private static Url = TaggedUrl.join('system/countries', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: CountryCollectionQuery): Promise<CountryItem[]> {
        const { data } = await this.http.get<{ items: CountryInternalItem[]; }>(CountryCollectionQueryHandlerBase.Url);
        const collection = data.items.map(i => ({
            id: i.id,
            code: i.code ?? '',
            default: i.default,
            euMember: i.euMember,
            name: i.name,
            externalId: i.externalId
        })).sort((a, b) => a.name.localeCompare(b.name, 'pl', { sensitivity: 'base' }));
        return collection;
    }
}
